"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const tslib_1 = require("tslib");
const cookie = tslib_1.__importStar(require("./cookie"));
const qb = tslib_1.__importStar(require("./qb"));
const getAccountInfo_1 = require("./getAccountInfo");
const setNovelToken_1 = require("./setNovelToken");
const type_1 = require("./type");
/**
 * 初始化QB登录态, 如果可以则加强qb分享能力
 */
function init() {
    var _a, _b, _c, _d;
    // 兼容处理-加强qb分享
    const mtt = window.mtt || null;
    if (!mtt) {
        const mtt = document.createElement('script');
        mtt.src = '//res.imtt.qq.com/res_mtt/component/mtt_qb.min.js';
        document.getElementsByTagName('head')[0].appendChild(mtt);
    }
    // 所有用户都应该设置guid
    if ((_b = (_a = qb.getBrowser()) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getBrowserParam) {
        (_d = (_c = qb.getBrowser()) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.getBrowserParam((params) => {
            if (params) {
                const { guid } = params;
                cookie.setCookie('q-guid', guid);
            }
        }, (err) => Promise.reject({
            code: err.code || type_1.UserErrCode.ERR_BROWSER_PARAM,
            msg: err.message,
        }));
    }
    else {
        return Promise.reject({ code: type_1.UserErrCode.ERR_NO_JSAPI, msg: 'should add apiJs - browser.app.getBrowserParam' });
    }
    // 判断用户的用户信息,如果有用户信息,则需要设置用户信息
    getAccountInfo_1.getAccountInfo().then((res) => {
        if (res.code === 0) {
            if (res.data) {
                return setNovelToken_1.setNovelToken(res.data);
            }
            // 没有info 说明未登陆 是需要清空掉登录信息的
            cookie.delLoginCookie();
        }
    })
        .catch(err => Promise.reject({
        code: type_1.UserErrCode.ERR_ACCOUNT_INFO,
        msg: `init -> getAccountInfo -> ${err.msg}`,
    }));
}
exports.init = init;
;
